// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"367":"35e5bd","404":"9d9e0b","792":"15df05"}[chunkId] + ".js";
};